import { FilterFilled } from '@ant-design/icons';
import {
  Checkbox,
  Col,
  Collapse,
  Divider,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import CheckableTag from 'antd/es/tag/CheckableTag';
import { CollapseProps, Table } from 'antd/lib';
import AllocateApi from 'apis/AllocateApi';
import * as XLSX from 'xlsx';
import {
  CheckIcon,
  ChevronDown,
  ChevronUp,
  DownloadIcon,
  EyeIcon2,
  FilterIcon,
  RedFlag,
  Remove,
} from 'assets/svg';
import Button from 'components/Button';
import { PORTFOLIO_STATUS } from 'constants/portfolioStatus';
import { STATUS } from 'constants/reponseStatus';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import convertStatusApproveOrder from 'constants/approveOrderStatus';
import moment from 'moment';
import BrandApi from 'apis/BrandApi';
import formatNumber from 'utils/formatNumber';
import CartApi from 'apis/CartApi';
import { openNotificationWithIcon } from 'utils/notification';

type FixedType = 'left' | 'right' | boolean;

interface IProps {
  cart: any;
}

export default function PerBranch(props: IProps): JSX.Element {
  const history = useHistory();
  const { Option } = Select;
  const { cart } = props;

  const [selectedTags, setSelectedTags] = useState<string>();
  const [bstSelected, setBST] = useState<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [checkAll, setCheckAll] = useState<boolean>(false);
  const [listBranchSelected, setListBranchSelected] = useState<any[]>([]);

  const [brandHandle, setBrandHandle] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isApprove, setIsApprove] = useState<boolean>(false);
  const [isManyApprove, setIsManyApprove] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const userParams = {
    page,
    page_size,
    cart_code: cart.cart_code,
    ...(formSubmitParams && formSubmitParams),
  };

  const {
    data: lstBrands,
    isLoading: isGetListBrandLoading,
    mutate: refetch,
  } = useMutation(['getAllocation', page], () =>
    BrandApi.getListOrderBranch(userParams)
  );

  const {
    mutate: getAllBranchs,
    isLoading: isGetAllBranchLoading,
    data: lstAllBrands,
  } = useMutation('getAllBrands', BrandApi.getListOrderBranch, {
    onSuccess: (response: any, variable: any) => {
      if (response.status === STATUS.SUCCESS) {
        if (variable.exportExcel) {
          exportFileExcel(response.data);
        }
        if (variable.checkAll) {
          setListBranchSelected(response.data);
        }
      }
    },
    onError: (error: any) => {
      console.log(error);
    },
  });

  function handleCheckboxChange(record: any, checked: boolean) {
    if (checked) {
      if (
        !listBranchSelected.some(
          (item: any) => item.ma_chi_nhanh === record.ma_chi_nhanh
        )
      ) {
        setListBranchSelected([...listBranchSelected, record]);
      }
    } else {
      const updatedList = listBranchSelected.filter(
        (item: any) => item.ma_chi_nhanh !== record.ma_chi_nhanh
      );
      setListBranchSelected(updatedList);
      // console.log(listBranchSelected);
    }
  }

  const sortData = [
    'Mới nhất',
    'Bán chạy',
    'Đăng ký kỳ trước',
    'Sức bán trung bình',
  ];

  const columnTops: ColumnsType<any> = [
    { title: 'Tủ Xman', width: 60 },
    { title: 'Đơn vị tính', width: 60 },
    { title: 'Tủ', width: 60 },
    { title: 'SL Mẫu', width: 60 },
    { title: 'Min kế hoạch', width: 60 },
    { title: 'Min hiện tại', width: 60 },
    { title: 'Min đã duyệt', width: 60 },
    { title: 'Max kế hoạch', width: 60 },
    { title: 'Doanh thu/tuần ', width: 60 },
  ];

  const items_top: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <p className="text-base font-bold text-primary-50 ml-2">
          Vốn theo dòng hàng
        </p>
      ),
      children: (
        <div>
          <Table
            rowKey={(record) => record.id}
            columns={columnTops}
            className="customTable"
            size="small"
            //  dataSource={lstBrands?.data}
            scroll={{ x: 958 }}
            //  loading={isGetListBrandLoading}
            pagination={false}
          />
        </div>
      ),
    },
  ];

  const columnBottoms: ColumnsType<any> = [
    {
      title: (
        <Checkbox
          checked={checkAll}
          onChange={(e) => {
            if (e.target.checked) {
              lstAllBrands?.data
                ? setListBranchSelected(lstAllBrands?.data)
                : getAllBranchs({
                    page: 1,
                    page_size: lstBrands?.total,
                    checkAll: true,
                    ...userParams,
                  });
            } else {
              setListBranchSelected([]);
            }
            setCheckAll(e.target.checked);
            // console.log(listBranchSelected);
          }}
        />
      ),
      dataIndex: 'isSelected',
      width: 30,
      align: 'center',
      render: (text, record) => (
        <Checkbox
          checked={listBranchSelected
            .map((item: any) => item.ma_chi_nhanh)
            .includes(record.ma_chi_nhanh)}
          onChange={(e) => handleCheckboxChange(record, e.target.checked)}
        />
      ),
    },
    {
      dataIndex: 'redflag',
      // width: 35,
      width: 0,
      render: () => '', //<RedFlag />
    },
    {
      title: 'STT',
      dataIndex: 'stt',
      width: 60,
      render: (value, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã chi nhánh',
      dataIndex: 'ma_chi_nhanh',
      width: 120,
    },
    {
      title: 'Tên chi nhánh',
      dataIndex: 'ten_chi_nhanh',
      width: 220,
    },
    {
      title: 'Trạng thái đơn hàng',
      dataIndex: 'order_status',
      width: 160,
      render: (value) => {
        return convertStatusApproveOrder(value);
      },
    },
    {
      title: 'CH đã đăng ký',
      dataIndex: 'registered_ch',
      width: 150,
    },
    {
      title: 'Nhãn hàng danh mục',
      dataIndex: 'portfolio_name',
      width: 160,
    },
    {
      title: 'SL đăng ký',
      dataIndex: 'registered_quantity',
      width: 100,
    },
    {
      title: 'Vốn đăng ký tối thiểu (Min)',
      dataIndex: 'von_min',
      width: 220,
      render: (value) => formatCurrencyVND(value),
    },
    {
      title: 'Vốn đăng ký tối đa (Max)',
      dataIndex: 'von_max',
      width: 200,
      render: (value) => formatCurrencyVND(value),
    },
    {
      title: 'Nguời phê duyệt',
      dataIndex: 'approver',
      width: 160,
    },
    {
      title: 'Người khai báo',
      dataIndex: 'declarer',
      width: 160,
    },
    {
      title: 'Thời gian yêu cầu',
      dataIndex: 'created_at',
      width: 160,
      render: (created_at) => moment(created_at).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Ngày phê duyệt',
      dataIndex: 'approved_at',
      width: 160,
    },
    {
      title: 'Lần phê duyệt',
      dataIndex: 'approved_times',
      width: 160,
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 180,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          <button onClick={() => console.log('EyeIcon')}>
            <EyeIcon2 />
          </button>

          <button onClick={() => checkApproveRejectBrand(record, true)}>
            <CheckIcon />
          </button>

          <button onClick={() => checkApproveRejectBrand(record, false)}>
            <Remove />
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    refetch();
  }, [page, page_size, formSubmitParams]);

  const handleChange = (tag: string, checked: boolean) => {
    if (tag == selectedTags) {
      setSelectedTags(undefined);
    } else {
      setSelectedTags(tag);
    }
  };

  function exportFileExcel(dataAllBrand: any) {
    const data = [];
    let index = 0;
    const headerRow = columnBottoms.filter(
      (column) =>
        column.dataIndex !== 'isSelected' &&
        column.dataIndex != undefined &&
        column.dataIndex !== 'redflag'
    );

    data.push(headerRow.map((column) => column.title));
    // data.push(
    //   headerRow.map((column) => {
    //     if (column.dataIndex === 'redflag') {
    //       return 'Đánh dấu';
    //     } else {
    //       return column.title;
    //     }
    //   })
    // );

    dataAllBrand.forEach((branch) => {
      const rowData = headerRow.map((column) => {
        switch (column.dataIndex) {
          case 'stt':
            return ++index;
          case 'ma_chi_nhanh':
            return branch[column.dataIndex];
          case 'status':
            return convertStatusApproveOrder(branch[column.dataIndex]);
          case 'von_min':
          case 'von_max':
            return formatCurrencyVND(branch[column.dataIndex]);
          case 'created_at':
            return moment(branch[column.dataIndex]).format('DD/MM/YYYY HH:mm');
          default:
            return typeof branch[column.dataIndex] === 'number' ||
              !isNaN(parseFloat(branch[column.dataIndex]))
              ? formatNumber(parseFloat(branch[column.dataIndex]))
              : branch[column.dataIndex];
        }
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `phe_duyet_chi_nhanh.xlsx`);
  }

  function handleFilter() {
    console.log('handleFilter');
  }

  function changeSelectSort() {
    console.log('changeSelectSort');
  }

  function goBack() {
    console.log('Function not implemented.');
  }

  function checkApproveRejectBrand(record: any, isApprove: boolean) {
    if (record.order_status == 1) {
      setModalOpen(true);
      setIsApprove(isApprove);
      setIsManyApprove(false);
      setBrandHandle(record);
    } else {
      openNotificationWithIcon(
        'error',
        `Chi nhánh này ${convertStatusApproveOrder(record.order_status)}`
      );
    }
  }

  function hanldeApproveBrands(isApprove: boolean) {
    if (listBranchSelected.length > 0) {
      setModalOpen(true);
      setIsApprove(isApprove);
      setIsManyApprove(true);
    } else {
      openNotificationWithIcon('error', `Chưa chọn chi nhánh`);
    }
  }

  async function ApprovalRejectBrand() {
    setIsLoading(true);
    if (isManyApprove && listBranchSelected.length != 0) {
      for (let i = 0; i < listBranchSelected.length; i++) {
        await CartApi.updateStatusCart_Brand({
          cart_order_branch_id: listBranchSelected[i].cart_order_branch_id,
          status: isApprove ? 2 : 3,
        }).catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
      }
      openNotificationWithIcon(
        'success',
        `${isApprove ? 'Phê duyệt' : 'Từ chối'} thành công`
      );

      setModalOpen(false);
      setIsLoading(false);
      setListBranchSelected([]);
      setCheckAll(false);
      refetch(userParams);
    } else {
      CartApi.updateStatusCart_Brand({
        cart_order_branch_id: brandHandle?.cart_order_branch_id,
        status: isApprove ? 2 : 3,
      })
        .then((res) => {
          openNotificationWithIcon(
            'success',
            `${isApprove ? 'Phê duyệt' : 'Từ chối'} thành công`
          );
          setModalOpen(false);
          setIsLoading(false);
          setListBranchSelected(
            listBranchSelected.filter(
              (value: any) => value != brandHandle?.cart_order_branch_id
            )
          );
          refetch(userParams);
        })
        .catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
    }
  }

  return (
    <Spin
      spinning={isGetListBrandLoading || isLoading || isGetAllBranchLoading}
    >
      <Row>
        <Col span={24} className="border-2 mb-5 border-blue-100">
          <Collapse
            expandIconPosition="right"
            ghost
            expandIcon={({ isActive }) =>
              isActive ? <ChevronUp /> : <ChevronDown />
            }
            size="small"
            items={items_top}
          />
        </Col>
      </Row>
      <Row
        justify={'space-between'}
        style={{
          paddingBottom: '10px',
          paddingLeft: '18px',
          paddingRight: '0px',
          alignItems: 'center',
        }}
      >
        <Row gutter={25} align={'middle'}>
          <Col className="font-bold">Sắp xếp</Col>
          <Space size={[0, 5]} wrap>
            {sortData.map((tag) => (
              <CheckableTag
                key={tag}
                checked={selectedTags?.includes(tag) ?? false}
                onChange={(checked) => handleChange(tag, checked)}
                style={{
                  borderRadius: '10px',
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  border: '#E4F3FF 1px solid',
                  backgroundColor: selectedTags?.includes(tag)
                    ? '#00538F'
                    : '#FFFFFF',
                  fontWeight: selectedTags?.includes(tag) ? '600' : '500',
                  color: selectedTags?.includes(tag) ? '#FFFFFF' : '#757779',
                }}
              >
                {tag}
              </CheckableTag>
            ))}
          </Space>
        </Row>
        <Space>
          <Button
            bgColor={'white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            onClick={() => {
              lstAllBrands?.data
                ? exportFileExcel(lstAllBrands?.data)
                : getAllBranchs({
                    page: 1,
                    page_size: lstBrands?.total,
                    exportExcel: true,
                    ...userParams,
                  });
            }}
          >
            <DownloadIcon /> Tải file Excel
          </Button>
          <Button
            bgColor={'white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            onClick={handleFilter}
          >
            <FilterIcon key={'e'} /> Lọc
          </Button>
          <Select
            placeholder="Sắp xếp nâng cao"
            className="w-full"
            allowClear
            value={bstSelected}
            onChange={(value) => {
              setBST(value);
              changeSelectSort();
            }}
          >
            {PORTFOLIO_STATUS.map((item) => (
              <Option value={item.values} key={item.name} defaultValue={null}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Space>
      </Row>
      <Table
        rowKey={(record) => record.ma_chi_nhanh}
        className="customTable mt-2"
        size="middle"
        columns={columnBottoms}
        dataSource={lstBrands?.data}
        pagination={{
          className: 'flex items-center',
          current: page,
          pageSize: page_size,
          total: lstBrands?.total,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20'],
          onChange: HocChangePagination(history),
        }}
        scroll={{ x: 958 }}
        loading={isGetListBrandLoading}
      />
      <div
        className="-mx-7 -mb-3 pr-3 pt-1"
        style={{ backgroundColor: '#f1f9ff' }}
      >
        <Row justify={'end'} className="mt-5 mr-5">
          <Space>
            <Button
              bgColor={'white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              onClick={goBack}
            >
              Trở lại
            </Button>
            <Button
              bgColor={'bg-red-500'}
              color={'text-white'}
              onClick={() => hanldeApproveBrands(false)}
            >
              Từ chối
            </Button>
            <Button
              bgColor={'bg-green-400'}
              color={'text-white'}
              onClick={() => hanldeApproveBrands(true)}
            >
              <span>Phê duyệt</span>
            </Button>
          </Space>
        </Row>
      </div>

      <Modal
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
        }}
        footer={null}
        width={'50%'}
      >
        <Content className="w-full">
          <p className="text-2xl font-bold">
            Phê duyệt {isManyApprove ? 'hàng loạt' : ''} cửa hàng
          </p>
          <Divider style={{ margin: '20px 0' }} />
          <div>
            <p className="text-base">
              Bạn có chắc muốn {isApprove ? 'phê duyệt' : 'từ chối'} cửa hàng:{' '}
              <span className="font-bold">
                {isManyApprove
                  ? listBranchSelected
                      .map((value: any) => value.ten_cua_hang)
                      .join(', ')
                  : brandHandle?.ten_cua_hang}
              </span>
            </p>
          </div>
          <Row justify="end" className="mt-4">
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
              customClass="text-neutral-50 mr-2"
              bgColor="white"
            >
              Huỷ
            </Button>
            <Button
              onClick={ApprovalRejectBrand}
              bgColor={isApprove ? 'bg-green-400' : 'bg-red-500'}
              color={'text-white'}
            >
              {isApprove ? 'Phê duyệt' : 'Từ chối'}
            </Button>
          </Row>
        </Content>
      </Modal>
    </Spin>
  );
}
